module.exports = __webpack_public_path__ + "img/HorizontalEdgesMask.95cedab4.svg";